import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { SidebarInset, SidebarProvider } from "@components/ui/sidebar";
import { useAppDispatch } from "@redux/hooks";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { logoutUser } from "@user-management-context/write/application/use-cases/user-logout/logout-user";
import { SideBar } from "@shared-kernel/primary/layout/side-bar/side-bar";
import { ImpersonationBanner } from "@user-management-context/primary/shared/impersonation-banner/impersonation-banner";
import { NoticeBanners } from "@shared-kernel/primary/shared/notice-banners/notice-banners";
import { SpinnerWithText } from "@shared-kernel/primary/shared/ui/spinner";
import { RoleTopBar } from "./role-top-bar";

export const AppShell = () => {
  const dispatch = useAppDispatch();
  const { user } = useSession();

  const onLogout = () => {
    dispatch(logoutUser()); // Resets Redux state + clears cookies & localStorage via listener
    window.location.href = "/login"; // Full reload destroys the store and in-memory repositories
  };

  if (!user) return null;

  return (
    <>
      <ScrollRestoration />
      <SidebarProvider>
        <SideBar user={user} logout={onLogout} />
        {/* min-w-0 flex-1: SidebarProvider is a flex row with a 255px ghost element (sidebar placeholder) + this div.
            w-full resolves to 100% of the viewport (1200px), starting at x=255 → extends to x=1455, causing page overflow.
            flex-1 min-w-0 fills only the remaining space (945px), keeping all content within the viewport. */}
        <div className="min-w-0 flex-1">
          <ImpersonationBanner />
          <NoticeBanners />
          <SidebarInset className="relative">
            <RoleTopBar />
            <div className={`mx-auto my-5 w-[90%] ${!user.isAdmin ? "max-w-[600px]" : ""}`}>
              <Suspense
                fallback={
                  <div className="flex h-64 items-center justify-center">
                    <SpinnerWithText text="Chargement..." />
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </>
  );
};
